<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_about')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.leaders')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <el-row :gutter="15">
                        <el-col :sm="24" :md="24" :lg="12">
                            <div v-for="rahbariyat in rahbariyats">
                              <div v-if="rahbariyat.sortOrder === 1" class="card card-lift shadow border-0 card-rahbariyat_pro  mb-3 mb-lg-3">
                                <img :src="imagePath + rahbariyat.titleImage" class="image_card_rahbariyat">
                                <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-UZ' ">{{rahbariyat.positionUz}}</span>
                                <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-QR' ">{{uzQr(rahbariyat, 'positionUzQr', 'positionUz')}}</span>
                                <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-CYR' ">{{rahbariyat.positionUzCyr}}</span>
                                <span class="card-rahbariyat_status" v-if="$i18n.locale === 'ru-RU' ">{{rahbariyat.positionRu}}</span>
                                <span class="card-rahbariyat_status" v-if="$i18n.locale === 'en-US' ">{{rahbariyat.positionUz}}</span>
                                <div class="card_rahbariyat_span_l vertical-center">
                                  <h3 class="rahbariyat_name" v-if="$i18n.locale === 'uz-UZ'">{{rahbariyat.fullNameUz}}</h3>
                                  <h3 class="rahbariyat_name" v-if="$i18n.locale === 'uz-QR'">{{uzQr(rahbariyat, 'fullNameUzQr', 'fullNameUz')}}</h3>
                                  <h3 class="rahbariyat_name" v-if="$i18n.locale === 'uz-CYR'">{{rahbariyat.fullNameUzCyr}}</h3>
                                  <h3 class="rahbariyat_name" v-if="$i18n.locale === 'ru-RU'">{{rahbariyat.fullNameRu}}</h3>
                                  <h3 class="rahbariyat_name" v-if="$i18n.locale === 'en-US'">{{rahbariyat.fullNameUz}}</h3>
                                  <span class="pro_status" v-if="$i18n.locale === 'uz-UZ' ">{{rahbariyat.yPositionUz}}</span>
                                  <span class="pro_status" v-if="$i18n.locale === 'uz-QR' ">{{uzQr(rahbariyat, 'yPositionUzQr', 'yPositionUz')}}</span>
                                  <span class="pro_status" v-if="$i18n.locale === 'uz-CYR' ">{{rahbariyat.yPositionUzCyr}}</span>
                                  <span class="pro_status" v-if="$i18n.locale === 'ru-RU' ">{{rahbariyat.yPositionRu}}</span>
                                  <span class="pro_status" v-if="$i18n.locale === 'en-US' ">{{rahbariyat.yPositionUz}}</span>
                                </div>
                              </div>
                            </div>

                            <div class="card card-lift shadow border-0 card-rahbariyat_info mb-3">
                                <strong class="card_rahbariyat_title">{{$t('leaders.title')}}</strong>
                                <div style="overflow: auto; height: 450px; margin-top: 8px;">
                            <span class="card_span_rahbariyat_text" v-html="$t('leaders.title_info')">
                            </span>
                                    <div v-for="rahbariyat in rahbariyats">
                                      <strong v-if="rahbariyat.sortOrder === 1 && $i18n.locale === 'uz-CYR'" class="rahbariyat_strong">
                                        Ҳурмат билан,<br>
                                        Ўзбекистон Республикаси Бош прокурори,<br>{{rahbariyat.fullNameUzCyr}}
                                      </strong>
                                      <strong v-if="rahbariyat.sortOrder === 1 && $i18n.locale === 'uz-UZ'" class="rahbariyat_strong">
                                        Hurmat bilan,<br>
                                        Oʼzbekiston Respublikasi Bosh prokurori,<br>{{rahbariyat.fullNameUz}}
                                      </strong>
                                      <strong v-if="rahbariyat.sortOrder === 1 && $i18n.locale === 'uz-QR'" class="rahbariyat_strong">
                                        Hurmat bilan,<br>
                                        Oʼzbekiston Respublikasi Bosh prokurori,<br>{{uzQr(rahbariyat, 'fullNameUzQr', 'fullNameUz')}}
                                      </strong>
                                      <strong v-if="rahbariyat.sortOrder === 1 && $i18n.locale === 'ru-RU'" class="rahbariyat_strong">
                                        С уважением,<br>
                                        Генеральный прокурор Республики Узбекистан,<br>{{rahbariyat.fullNameRu}}
                                      </strong>
                                      <strong v-if="rahbariyat.sortOrder === 1 && $i18n.locale === 'en-US'" class="rahbariyat_strong">
                                        Hurmat bilan,<br>
                                        Oʼzbekiston Respublikasi Bosh prokurori,<br>{{rahbariyat.fullNameUz}}
                                      </strong>
                                    </div>
                                </div>
                            </div>

                        </el-col>
                        <el-col :sm="24" :md="24" :lg="12" v-for="rahbariyat in rahbariyats">
                            <div v-if="rahbariyat.sortOrder > 1" class="card card-lift shadow border-0 card-rahbariyat_pro_urin mb-3 mb-lg-3">
                                <img :src="imagePath + rahbariyat.titleImage" class="image_card_rahbariyat_urin">
                              <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-UZ' ">{{rahbariyat.positionUz}}</span>
                              <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-QR' ">{{uzQr(rahbariyat, 'positionUzQr', 'positionUz')}}</span>
                              <span class="card-rahbariyat_status" v-if="$i18n.locale === 'uz-CYR' ">{{rahbariyat.positionUzCyr}}</span>
                              <span class="card-rahbariyat_status" v-if="$i18n.locale === 'ru-RU' ">{{rahbariyat.positionRu}}</span>
                              <span class="card-rahbariyat_status" v-if="$i18n.locale === 'en-US' ">{{rahbariyat.positionUz}}</span>
                              <div class="card_rahbariyat_span_l vertical-center">
                                <h4 class="rahbariyat_name" v-if="$i18n.locale === 'uz-UZ'">{{rahbariyat.fullNameUz}}</h4>
                                <h4 class="rahbariyat_name" v-if="$i18n.locale === 'uz-QR'">{{uzQr(rahbariyat, 'fullNameUzQr', 'fullNameUz')}}</h4>
                                <h4 class="rahbariyat_name" v-if="$i18n.locale === 'uz-CYR'">{{rahbariyat.fullNameUzCyr}}</h4>
                                <h4 class="rahbariyat_name" v-if="$i18n.locale === 'ru-RU'">{{rahbariyat.fullNameRu}}</h4>
                                <h4 class="rahbariyat_name" v-if="$i18n.locale === 'en-US'">{{rahbariyat.fullNameUz}}</h4>
                                <span class="pro_status" v-if="$i18n.locale === 'uz-UZ' ">{{rahbariyat.yPositionUz}}</span>
                                <span class="pro_status" v-if="$i18n.locale === 'uz-QR' ">{{uzQr(rahbariyat, 'yPositionUzQr', 'yPositionUz')}}</span>
                                <span class="pro_status" v-if="$i18n.locale === 'uz-CYR' ">{{rahbariyat.yPositionUzCyr}}</span>
                                <span class="pro_status" v-if="$i18n.locale === 'ru-RU' ">{{rahbariyat.yPositionRu}}</span>
                                <span class="pro_status" v-if="$i18n.locale === 'en-US' ">{{rahbariyat.yPositionUz}}</span>
                              </div>

                            </div>

                        </el-col>
                    </el-row>
                </div>
            </section>
        </div>
    </div>
</template>
<script>

    import axios from "axios";

    export default {
        data() {
            return {
                imagePath: 'https://www.prokuratura.uz/api/download/',
                rahbariyats: []
            }
        },
        mounted() {
            axios
                .get(`https://www.prokuratura.uz/api/rahbariyats-for-web`)
                .then( response => {
                  this.rahbariyats = response.data
                })
                .catch( error => {
                  console.log(error)
                })
        },
        methods: {
          uzQr(item, qrKey, fallbackKey) {
            return (item && item[qrKey]) || (item && item[fallbackKey]) || "";
          }
        }
    }
</script>
<style scoped>
    /deep/ .px-4 {
        min-height: 356px;
    }

    /deep/ .profile-page .card-profile {
        margin-top: 70px;
    }

    /deep/ .el-dialog__header {
        background: #fff;
    }

    /deep/ .el-dialog {
        width: 50%;
    }
    .dialog_rahbarname {
        margin-top: 10px;
        margin-bottom: 0px;
    }
    @media only screen and (max-width: 767px) {
        /deep/ .el-dialog {
            width: 90%!important;
        }
    }
</style>
